// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightInfoBanner-cls1_zR0","cls2":"CiterightInfoBanner-cls2_cDk CiterightInfoBanner-cls1_zR0"};